/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompassVoltageSensorSettings
 */
export interface CompassVoltageSensorSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CompassVoltageSensorSettings
     */
    sensitivity_smart_adaptive_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompassVoltageSensorSettings
     */
    sensitivity_disabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompassVoltageSensorSettings
     */
    range: number;
    /**
     * 
     * @type {number}
     * @memberof CompassVoltageSensorSettings
     */
    sensitivity: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompassVoltageSensorSettings
     */
    sensitivity_locked: boolean;
}

/**
 * Check if a given object implements the CompassVoltageSensorSettings interface.
 */
export function instanceOfCompassVoltageSensorSettings(value: object): value is CompassVoltageSensorSettings {
    if (!('sensitivity_smart_adaptive_on' in value) || value['sensitivity_smart_adaptive_on'] === undefined) return false;
    if (!('sensitivity_disabled' in value) || value['sensitivity_disabled'] === undefined) return false;
    if (!('range' in value) || value['range'] === undefined) return false;
    if (!('sensitivity' in value) || value['sensitivity'] === undefined) return false;
    if (!('sensitivity_locked' in value) || value['sensitivity_locked'] === undefined) return false;
    return true;
}

export function CompassVoltageSensorSettingsFromJSON(json: any): CompassVoltageSensorSettings {
    return CompassVoltageSensorSettingsFromJSONTyped(json, false);
}

export function CompassVoltageSensorSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompassVoltageSensorSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'sensitivity_smart_adaptive_on': json['sensitivity_smart_adaptive_on'],
        'sensitivity_disabled': json['sensitivity_disabled'],
        'range': json['range'],
        'sensitivity': json['sensitivity'],
        'sensitivity_locked': json['sensitivity_locked'],
    };
}

export function CompassVoltageSensorSettingsToJSON(json: any): CompassVoltageSensorSettings {
    return CompassVoltageSensorSettingsToJSONTyped(json, false);
}

export function CompassVoltageSensorSettingsToJSONTyped(value?: CompassVoltageSensorSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sensitivity_smart_adaptive_on': value['sensitivity_smart_adaptive_on'],
        'sensitivity_disabled': value['sensitivity_disabled'],
        'range': value['range'],
        'sensitivity': value['sensitivity'],
        'sensitivity_locked': value['sensitivity_locked'],
    };
}

